// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSideNavigation_root__2_pMP","container":"LayoutSideNavigation_container__1p2gS","layoutWrapperMain":"LayoutSideNavigation_layoutWrapperMain__3gha1"};